// 获取推荐作业列表
export const HOMEWORK_GET_LIST = 'HOMEWORK_GET_LIST';
// 设置作业列表
export const HOMEWORK_SET_LIST = 'HOMEWORK_SET_LIST';
// 添加作业
export const HOMEWORK_ADD_HOMEWORK = 'HOMEWORK_ADD_HOMEWORK';
// 删除作业
export const HOMEWORK_REMOVE_HOMEWORK = 'HOMEWORK_REMOVE_HOMEWORK';
// 批量删除作业
export const HOMEWORK_BATCH_REMOVE = 'HOMEWORK_BATCH_REMOVE';
// 设置当前展示的内容
export const HOMEWORK_SET_CONTENT = 'HOMEWORK_SET_CONTENT';
// 引用作业
export const HOMEWORK_ADD_REFER = 'HOMEWORK_ADD_REFER';
// 移除引用
export const HOMEWORK_REMOVE_REFER = 'HOMEWORK_REMOVE_REFER';
// 移动位置
export const HOMEWORK_MOVE_POSITION = 'HOMEWORK_MOVE_POSITION';
// 课节信息
export const HOMEWORK_SET_LESSON_INFO = 'HOMEWORK_SET_LESSON_INFO';
// 设置作业
export const HOMEWORK_SET_HOMEWORK = 'HOMEWORK_SET_HOMEWORK';
// 设置题目的筛选条件
export const HOMEWORK_SET_SELECT = 'HOMEWORK_SET_SELECT';
// 作业信息
export const HOMEWORK_SET_HOMEWORK_INFO = 'HOMEWORK_SET_HOMEWORK_INFO';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_homeworks.js